import * as React from 'react';
import { getProductBlockDisplayDetails } from '@grandvisionhq/fun-search';
import { useVariantSwitcher, ProductBlock } from '@grandvisionhq/lib-visuals';
import { useProductLink } from '@grandvisionhq/products';
import '@grandvisionhq/state';
import '@swc/helpers';
import '@bloomreach/react-sdk';
import '../../../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/utils';
import '@grandvisionhq/common';
import '../../../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../../../operations/mutations/signup-promotion.js';
import '../../../../operations/mutations/subscribe-newsletter.js';
import '../../../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachSiteLogos } from '../../../../hooks/use-bloomreach-site-logos.js';
import '../../../../hooks/use-breakpoint-visibility.js';

const ProductListingRowBlock = ({ listingProduct , selectedVariant  })=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { reimbursable  } = useBloomreachSiteLogos();
    const variants = [
        listingProduct.masterVariant,
        ...listingProduct.variants
    ];
    const { activeSku , activeVariant , handleVariantChange  } = useVariantSwitcher({
        variants,
        initialSku: selectedVariant !== null && selectedVariant !== void 0 ? selectedVariant : listingProduct.masterVariant.sku
    });
    const link = useProductLink(listingProduct.slug, activeSku, listingProduct.productType);
    if (!activeVariant) {
        return null;
    }
    const frontImage = (ref = activeVariant.images) === null || ref === void 0 ? void 0 : ref[0];
    const angleImage = (ref1 = activeVariant.images) === null || ref1 === void 0 ? void 0 : ref1[1];
    const displayDetails = getProductBlockDisplayDetails({
        product: listingProduct,
        variant: activeVariant
    });
    return /*#__PURE__*/ React.createElement(ProductBlock.Outer, null, /*#__PURE__*/ React.createElement(ProductBlock.Inner, null, /*#__PURE__*/ React.createElement(ProductBlock.Header, null, /*#__PURE__*/ React.createElement(ProductBlock.Header.Left, {
        tag: activeVariant.tag,
        isProductReimbursable: activeVariant.isInsuranceReimbursable,
        defaultReimbursableLogo: reimbursable
    }), /*#__PURE__*/ React.createElement(ProductBlock.Header.Right, {
        sku: activeVariant.sku
    })), /*#__PURE__*/ React.createElement(ProductBlock.Details, {
        href: link
    }, /*#__PURE__*/ React.createElement(ProductBlock.Details.Heading, null, displayDetails.heading), /*#__PURE__*/ React.createElement(ProductBlock.Details.Caption, null, displayDetails.caption)), /*#__PURE__*/ React.createElement(ProductBlock.Images, {
        href: link,
        frontUrl: (frontImage === null || frontImage === void 0 ? void 0 : frontImage.url) || '',
        frontAlt: frontImage === null || frontImage === void 0 ? void 0 : frontImage.altTag,
        angleUrl: angleImage === null || angleImage === void 0 ? void 0 : angleImage.url
    }), /*#__PURE__*/ React.createElement(ProductBlock.Pricing, {
        originalPrice: activeVariant.pricing.price.originalPrice,
        discountedPrice: (ref2 = activeVariant.pricing.price.discount) === null || ref2 === void 0 ? void 0 : ref2.price,
        discountLabel: (ref3 = activeVariant.pricing.price.discount) === null || ref3 === void 0 ? void 0 : ref3.description,
        discountValue: (ref4 = activeVariant.pricing.price.discount) === null || ref4 === void 0 ? void 0 : ref4.badge,
        bestPrice: activeVariant.pricing.bestPrice,
        pricePerUnit: (ref5 = activeVariant.pricing.pricePerUnit) === null || ref5 === void 0 ? void 0 : ref5.amount,
        currency: activeVariant.pricing.price.currencyCode,
        isCentAmount: activeVariant.pricing.price.isCentAmount
    }), /*#__PURE__*/ React.createElement(ProductBlock.Footer, null, /*#__PURE__*/ React.createElement(ProductBlock.Footer.Variants, {
        variants: variants,
        activeSku: activeSku,
        onVariantChange: handleVariantChange
    }))));
};

export { ProductListingRowBlock };
//# sourceMappingURL=ProductListingRowBlock.js.map
